import './Page.css';

const reviews = [
  { quote: 'I was writing the same generic essay for every school. My coach helped me reflect deeply, and my writing actually felt like me. It changed everything.', name: '— Nina S., Class of 2024' },
  { quote: 'I went from a 1210 to a 1380 after just six weeks. Practicing daily in the question bank and reviewing every session made the difference.', name: '— Samir K., Grade 11' },
  { quote: "My daughter was never confident in her writing and grammar, but after two months in the ELA program, she really improved. The sessions were clear and helpful, and the feedback showed her exactly what to work on.", name: '— Preeti D., Parent' },
  { quote: "Scholar Sphere wasn't just another tutoring service. My son connected with his tutor for 1:1 tailored SAT session, understood the strategies, and went into his test feeling prepared.", name: '— Rajesh P., Parent' },
  { quote: 'I connected with Scholar Sphere just 15 days before my essay deadline. My tutor was very helpful in and gave me the structure, guidance, and support I needed—exactly when I needed it most.', name: '— Maya L., Class of 2025' },
  { quote: 'Reading comprehension was always my biggest challenge—especially understanding paired passages and identifying author tone. After 10 private sessions focused on active reading strategies, evidence-based questions, and time management, my score jumped by 120 points. I finally feel confident, and I\'m really happy with the results.', name: '— Kavita J., Student' },
  { quote: 'Being in New York and taking the Regents exams was a tough challenge for me. But thanks to my tutor\'s guidance and support, I performed much better and passed with strong grades.', name: '— Rashika M, Student' },
  { quote: 'I take regular sessions with my tutor before exams, especially for math and physics. It really helps me review everything and clear up last-minute questions. Those sessions make a big difference—I\'ve been able to keep my grade at an A.', name: '— Anika S' },
  { quote: 'AP Physics used to feel so hard and confusing, but my tutor really helped me break it down step by step. After a few weeks, I actually started to enjoy it—and I ended up getting an A in the class.', name: '— Jordan T., Class of 2024' },
  { quote: "I started with a bunch of ideas that didn't really connect. My tutor helped me figure out what mattered most and how to tie it all together. In the end, my application told a clear, thoughtful story I felt proud of.", name: '— Diego R., Class of 2024' },
  { quote: "After just a few tailored sessions, my daughter's ACT score went up by 4 points. But more than that, she finally felt confident. She walked out of her final test smiling—and that meant a lot to us.", name: '— Melissa D., Parent' },
  { quote: "I honestly never thought I'd enjoy SAT prep—but working through the question bank and reviewing my sessions made the progress feel real. My tutor kept me motivated and every session was worth it.", name: '— Ishaan V., Grade 9' },
];

export default function ReviewsPage() {
  return (
    <div className="page-wrap">
      <div className="navy-hero">
        <div className="container">
          <h1>Success Stories</h1>
          <p className="page-hero-sub">Real Stories. Real Results.</p>
          <p style={{ color: 'rgba(255,255,255,0.8)', maxWidth: 600, margin: '0 auto 28px', fontSize: 15, lineHeight: 1.7 }}>
            What Families Are Saying About Scholar Sphere.
          </p>
        </div>
      </div>

      <div className="container page-body">
        <div className="page-section">
          <p className="page-p">
            At Scholar Sphere, our students grow in confidence, improve their scores, and build momentum for academic and college success. These testimonials reflect the impact of personalized instruction, expert coaching, and the supportive relationships we build with every student and family.
          </p>
        </div>

        <div className="page-section">
          <h2 className="section-heading">What Students and Parents Are Saying</h2>
          <div className="mini-test-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
            {reviews.map((r, i) => (
              <div className="mini-test-card" key={i}>
                <p className="mini-test-quote">&ldquo;{r.quote}&rdquo;</p>
                <div className="mini-test-name">{r.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Student Spotlight */}
        <div className="info-card highlight-card">
          <h2 className="section-heading">Student Spotlight</h2>
          <h3 className="info-subhead">Ananya R. — High School Junior</h3>
          <p className="page-p">
            Ananya started with a 1250 on her first diagnostic. After 8 weeks of personalized support and weekly review sessions, she scored a 1460 on her official test. She credits her tutor for helping her manage pacing, focus under pressure, and trust her instincts.
          </p>
        </div>

        <div className="cta-strip" style={{marginBottom: 32}}>
          <h3>Ready to Be Our Next Success Story?</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: 24, fontSize: 15 }}>
            Whether you're focused on test prep, academic support, or building the perfect college application—Scholar Sphere can help you get there.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="https://secure.tutorcruncher.com/scholar-sphere/signup/client/" target="_blank" rel="noreferrer" className="btn-gold">Book a Free Consultation</a>
            <a href="/sat-prep" className="btn-outline-white">Explore Our Programs</a>
          </div>
        </div>

        <div className="page-section" style={{ textAlign: 'center', marginTop: 40 }}>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: 'var(--navy)', marginBottom: 12 }}>Have a Story to Share?</h3>
          <p className="page-p" style={{ maxWidth: 480, margin: '0 auto 20px' }}>
            We're proud of the growth our students experience—and we'd love to feature yours.
          </p>
          <a href="/contact" className="btn-navy">Submit a Testimonial</a>
        </div>
      </div>
    </div>
  );
}
